import React from "react";
import EdelLogoCenter from "../../UI/EdelLogoCenter/EdelLogoCenter";
import "./Layout.scss";
import DeviceContext from "../../../components/Services/identifyDevice";
export interface StatusLayoutProps {
  edelLogoClass?: string;
  statusClassName?: string;
}

const StatusLayout: React.FC<StatusLayoutProps> = (props) => {
  const isDesktop = DeviceContext().isDesktop;

  return (
    <>
      <div
        className={
          props?.statusClassName !== undefined && props?.statusClassName
            ? props?.statusClassName
            : "statusLayout"
        }
      >
        <EdelLogoCenter
          headerLogoClassName={
            isDesktop && props?.edelLogoClass ? props?.edelLogoClass : ""
          }
        />
        {props.children}
      </div>
    </>
  );
};

export default StatusLayout;
